<template>
    <div>
        <validation-observer ref="observer">
            <div
                v-if="errorMessage"
                class="alert alert-danger"
            >
                {{ errorMessage }}
            </div>
            <form
                :id="id"
                class="text-start"
                @submit.prevent="$emit('on-submit')"
            >
                <slot />
            </form>
        </validation-observer>
    </div>
</template>

<script>
    import { ValidationObserver } from 'vee-validate'
    import { log } from '@/utils/logger'

    export default {
        name: 'FormContainer',
        components: {
            'validation-observer': ValidationObserver,
        },
        props: {
            id: {
                type: String,
                default: undefined,
            },
        },
        mounted() {
            log.info('FormContainer ID: %{id}', { id: this.id })
        },
        data() {
            return {
                errorMessage: null,
            }
        },
        methods: {
            applyGeneralError: function (errorMessage) {
                log.info('Apply general error: %{errorMessage}', { errorMessage })
                this.errorMessage = errorMessage
            },
            applyErrorOnField: function (errorObject) {
                log.info('Apply error on field: %{errorObject}', { errorObject: JSON.stringify(errorObject) })
                this.$refs.observer.setErrors(errorObject)
            },
        },
    }
</script>
